// A recipe ingredient row either comes from an external Ingredient node
// (the historic behaviour) or from the process's own Farm Gate Cultivation,
// when the farmer sets a produce type directly on the Cultivar instead of
// connecting an Ingredient node. A row with no sourceType is legacy data and
// is treated as INGREDIENT.
export enum RecipeSourceType {
  INGREDIENT = "ingredient",
  CULTIVATION = "cultivation"
}
